<template>
  <div class="lg:mt-3 mt-8">
    <div class="text-2xl flex items-center justify-start md:gap-5 my-4 lg:hidden title font-semibold">
      <p>My Orders</p>
      <Clinic :onChange="() => { }" :title="''" />
    </div>
    <ClinicOrderList viewDetailRoute="OrderDetail" v-if="!doctorApprovalFlow"></ClinicOrderList>
    <vs-tabs v-else
      v-model="selectedTab"
      class="order-list">
      <vs-tab label="Orders">
        <ClinicOrderList viewDetailRoute="OrderDetail"></ClinicOrderList>
      </vs-tab>
      <vs-tab label="Requests">
        <ClinicOrderRequestList viewDetailRoute="OrderDetail"></ClinicOrderRequestList>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ClinicOrderList from '../../../components/org-owner/order/ClinicOrderList';
import ClinicOrderRequestList from '@/views/components/org-owner/order/ClinicOrderRequestList.vue';
import Clinic from '../../../components/shop/clinic.vue';

export default {
  name: 'OrderList',
  components: { ClinicOrderList, Clinic, ClinicOrderRequestList },
  data() {
    return {
      selectedTab: 0,
      doctorApprovalFlow: false,
    };
  },
  methods: {
    ...mapActions('organization', [
      'checkOrgClinicsDoctorApproval',
    ]),
    async checkClinicsDoctorApprovalFlow() {
      try {
        const organizationId = localStorage.getItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
        );

        const { data: { data: doctorApprovalFlow }} = await this.checkOrgClinicsDoctorApproval(organizationId);

        this.doctorApprovalFlow = doctorApprovalFlow;

        if (this.$route.query.tab) this.selectedTab = parseInt(this.$route.query.tab) - 1;
      } catch (err) {
        console.log('Error fetching checking org clinics doctor approval:: ', err );
      }
    },
  },
  async created() {
    await this.checkClinicsDoctorApprovalFlow();
  },
};
</script>

<style scoped>
.title {
  margin-top: -30px !important;
}
</style>
